
//*****************************************************************
//**************************** import *****************************
//*****************************************************************
// import * as bootstrap from 'bootstrap'; // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.
// or, specify which plugins you need:
//import { Tooltip, Toast, Popover, Modal } from 'bootstrap';
import { Modal } from 'bootstrap';
window.Modal = Modal; // Espone Modal globalmente

import Cleave from 'cleave.js';
require('cleave.js/dist/addons/cleave-phone.it');
//import path from '/_common/prefix.json';

import Swiper from 'swiper'; // ref: https://swiperjs.com/get-started#install-from-npm
// specify which plugins you need:
// import { Navigation, Pagination, Autoplay, A11y, EffectFade, Autoplay} from 'swiper/modules';
import { Navigation, Pagination, A11y } from 'swiper/modules';

import EnergySaver from './js/vendors/energy-saver';

import AOS from 'aos';

import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core' // ref: https://zxcvbn-ts.github.io/zxcvbn/guide/getting-started/
//import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common'
//import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en'

document.addEventListener("DOMContentLoaded", () => {
	
});

//*****************************************************************
//************************ function *******************************
//*****************************************************************

// Fix CookieScript accessibilità, aria-label di Cookie Script
/**
 * Esegue un callback quando un elemento con l'id specificato viene aggiunto al DOM.
 * Si disconnette automaticamente dopo aver trovato l'elemento o dopo il timeout.
 * @param {string} id - L'id dell'elemento da osservare.
 * @param {function(HTMLElement): void} callback - Funzione chiamata con l'elemento trovato.
 * @param {number} [timeoutMs=10000] - Timeout in ms prima di rinunciare (default 10s).
 */
const onElementAdded = (id, callback, timeoutMs = 10000) => {
	const observer = new MutationObserver((mutationsList) => {
		const found = mutationsList.some(() => document.getElementById(id));

		if (found) {
			clearTimeout(timeout);
			observer.disconnect();
			callback(document.getElementById(id));
			//console.log(`onElementAdded: elemento "${id}" trovato!`)
		}
	});

	const timeout = setTimeout(() => {
		observer.disconnect();
		//console.warn(`onElementAdded: elemento "${id}" non trovato entro ${timeoutMs}ms.`);
	}, timeoutMs);

	observer.observe(document.body, { childList: true, subtree: true });
};
/**
 * Aggiunge attributi aria-label agli elementi di CookieScript per migliorare l'accessibilità.
 * Gestisce la race condition in cui il badge può essere presente o meno al momento del CookieScriptLoaded.
 */
export function initCookieScriptAccessibility() {
	const LABEL_BADGE = "Gestione preferenze cookie";

	window.addEventListener("CookieScriptLoaded", function () {
		// Il badge può essere già presente al momento dell'evento — impostazione anticipata
		// come fallback per la race condition con onElementAdded.
		const cookiescript_badge = document.getElementById("cookiescript_badge");
		cookiescript_badge?.setAttribute("aria-label", LABEL_BADGE);

		onElementAdded("cookiescript_injected_wrapper", function (cookiescript_injected_wrapper) {
			const cookiescript_badge = cookiescript_injected_wrapper?.querySelector("#cookiescript_badge");
			cookiescript_badge?.setAttribute("aria-label", LABEL_BADGE);

			const cookiescript_close = cookiescript_injected_wrapper?.querySelector("#cookiescript_close");
			cookiescript_close?.setAttribute("aria-label", "Chiudi la finestra di dialogo dei cookie");

			const cookiescript_readmore = cookiescript_injected_wrapper?.querySelector("#cookiescript_readmore");
			cookiescript_readmore?.setAttribute("aria-label", "Leggi di più (apre una nuova scheda)");
		});
	});
}

// Swiper // Inizializza uno slider Swiper se presente in pagina
export function initSwiper() {
	const swiperElm = document.querySelector('.my--swiper');
	if (!swiperElm) {
		return;
	}

	// Traduzioni per l'accessibilità (A11y) di Swiper in italiano
	 const swiperTranslations = {
	     firstSlideMessage: `Questa è la prima slide`,
	     lastSlideMessage: `Questa è l'ultima slide`,
	     nextSlideMessage: `Vai alla prossima slide`,
	     paginationBulletMessage: `Vai alla slide {{index}}`,
	     prevSlideMessage: `Vai alla slide precedente`,
	     slideLabelMessage: `{{index}} di {{slidesLength}}`
	 }

	// Crea l'istanza Swiper con i parametri definiti
	// Moduli Swiper importati (es. con import { Navigation, Pagination, A11y } from 'swiper/modules';)
	const swiperArgs = {
		modules: [Navigation, Pagination, A11y],

		// Accessibilità
		a11y: swiperTranslations,

		// Non cicla le slide (no loop infinito)
		loop: false,

		// Inizializzazione manuale (chiameremo noi .init())
		init: false,

		// Classe CSS personalizzata per le singole slide
		slideClass: 'my--slide',

		// Configurazione dei puntini di paginazione
		pagination: {
			el: '.my--pagination',
			clickable: true, // consente cliccare sui pallini per cambiare slide
		},

		// Pulsanti di navigazione avanti/indietro
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		// Breakpoint responsive per numero di slide visibili e spaziatura
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 10
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 30
			}
		}
	};

	// Crea l'istanza Swiper con i parametri definiti
	let mySwiper = new Swiper(swiperElm, swiperArgs);

	// TODO: evento da eseguire all'inizializzazione
	// es. applicare una classe aggiuntiva se ci sono più di una slide
	// mySwiper.on('init', (e) => {
	//   if (e.slides.length > 1) {
	//     swiperElm.classList.add('margined-left');
	//   }
	// });

	// Inizializza Swiper manualmente (dato che init: false)
	mySwiper.init();
}

/**
 * Inizializza i formati automatici sugli input tramite Cleave.js.
 * Viene richiamata su ogni pagina — ogni blocco verifica prima l'esistenza degli elementi.
 */
export function initCleave() {
	// 📅 Data di nascita - formato data (gg/mm/aaaa)
	const datanascita = document.querySelector('input[id$="DataDiNascita"]');
	if (datanascita) {
		new Cleave(datanascita, {
			date: true,
			datePattern: ['d', 'm', 'Y']
		});
	}

	// 📍 CAP - solo numeri, 5 cifre
	const cap = document.querySelector('input[id$="Cap"]');
	if (cap) {
		new Cleave(cap, {
			blocks: [5],
			numericOnly: true
		});
	}

	// 📞 Telefono - formato telefonico italiano, massimo 11 cifre, senza separatori
	const telefono = document.querySelector('input[id$="Telefono"]');
	if (telefono) {
		new Cleave(telefono, {
			phone: true,
			phoneRegionCode: 'it',
			blocks: [11],
			numericOnly: true,
			delimiter: ''
		});
	}

	// 🆔 Codice fiscale - 16 caratteri alfanumerici, tutti maiuscoli
	const codicefiscale = document.querySelector('input[id$="CodiceFiscale"]');
	if (codicefiscale) {
		new Cleave(codicefiscale, {
			blocks: [16],
			uppercase: true
		});
	}

	// 🧾 Partita IVA - 11 cifre numeriche
	const partitaiva = document.querySelector('input[id$="PartitaIva"]');
	if (partitaiva) {
		new Cleave(partitaiva, {
			blocks: [11],
			numericOnly: true
		});
	}

	// *** SCONTRINO

	// 📆 Data scontrino - formato data (gg/mm/aaaa)
	// Seleziona tutti gli input che terminano con 'DataAcquisto' (es. Input1_DataAcquisto, Input2_DataAcquisto)
	const dataAcquistoInputs = document.querySelectorAll('input[id$="DataAcquisto"]');
	if (dataAcquistoInputs.length > 0) {
		dataAcquistoInputs.forEach(input => {
			new Cleave(input, {
				date: true,
				delimiter: '/',
				datePattern: ['d', 'm', 'Y']
			});
		});
	}

	// 🕒 Orario scontrino - formato ora (hh:mm)
	// Seleziona tutti gli input che terminano con 'OrarioAcquisto' (es. Input1_OrarioAcquisto, Input2_OrarioAcquisto)
	const orarioAcquistoInputs = document.querySelectorAll('input[id$="OrarioAcquisto"]');
	if (orarioAcquistoInputs.length > 0) {
		orarioAcquistoInputs.forEach(input => {
			new Cleave(input, {
				time: true,
				delimiter: ':',
				timePattern: ['h', 'm']
			});
		});
	}

	// 🧾 Numero scontrino/acquisto - formato con due blocchi di 4 cifre separati da trattino (es. 1234-5678)
	// InputFattura_NumeroAcquisto è escluso perché usa un formato diverso (fattura vs scontrino)
	const numeroAcquistoInputs = Array.from(document.querySelectorAll('input[id$="NumeroAcquisto"]'))
		.filter(input => input.id !== 'InputFattura_NumeroAcquisto');
	if (numeroAcquistoInputs.length > 0) {
		numeroAcquistoInputs.forEach(input => {
			new Cleave(input, {
				blocks: [4, 4],
				delimiter: '-',
				numericOnly: true
			});
		});
	}

	// 💶 Importo scontrino/acquisto - numerico con 2 decimali, virgola come separatore decimale
	const importoAcquistoInputs = document.querySelectorAll('input[id$="ImportoAcquisto"]');
	if (importoAcquistoInputs.length > 0) {
		importoAcquistoInputs.forEach(input => {
			new Cleave(input, {
				blocks: [6], // numero massimo di cifre prima del separatore
				numeral: true,
				delimiter: '', // niente separatore per le migliaia
				numeralDecimalScale: 2, // due cifre decimali
				numeralDecimalMark: ',', // separatore decimale (virgola per lo stile italiano)
			});
		});
	}
}

// EnergySaver // Inizializza il modulo EnergySaver per ridurre l'impatto energetico del sito
export function initEnergySaver() {
	const energyS = new EnergySaver({
		idle: 300000, // ⚡ Tempo di inattività (30 secondi) dopo il quale attivare la modalità "risparmio energia"
		enableZeroImpact: false, // ✅ Abilita la modalità "Zero Impact" per ridurre il consumo energetico
		enableZeroImpactTarget: "#zeroimpact", // 🎯 Selettore del contenitore DOM da aggiornare quando la modalità è attiva
		enableCredits: true // 🙌 Mostra i crediti dell'autore/plugin (utile per attribuzione)
	});
}

/**
 * Anima l'opacità di un elemento da 0 a 1 (fade-in) o da 1 a 0 (fade-out).
 * @param {HTMLElement} el - L'elemento da animare.
 * @param {number} time - Durata dell'animazione in ms.
 * @param {'in'|'out'} direction - Direzione dell'animazione.
 * @param {function} [onComplete] - Callback eseguito al termine dell'animazione.
 */
function fade(el, time, direction, onComplete) {
	el.style.opacity = direction === 'in' ? 0 : 1;
	let last = Date.now();

	const tick = () => {
		const delta = (Date.now() - last) / time;
		el.style.opacity = +el.style.opacity + (direction === 'in' ? delta : -delta);
		last = Date.now();

		if (direction === 'in' ? +el.style.opacity < 1 : +el.style.opacity > 0) {
			(window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
		} else if (onComplete) {
			onComplete();
		}
	};

	tick();
}

/**
 * Mostra una schermata di caricamento con spinner e fade-in animato.
 * @param {boolean} [hide=false] - Se true, nasconde automaticamente il loader dopo 5 secondi.
 * @param {Event} [event] - Evento opzionale di cui prevenire il comportamento predefinito.
 */
export function showLoading(hide = false, event) {
	if (event) {
		event.preventDefault();
	}

	const loadingPage = document.createElement('div');
	loadingPage.classList.add('page-loader');
	loadingPage.style.opacity = 0;
	loadingPage.innerHTML = `
		<span class="spinner-border" role="status"></span>
		<span class="text-muted visually-hidden">Loading page...</span>
	`;
	document.body.prepend(loadingPage);

	fade(loadingPage, 250, 'in');

	if (hide) {
		const delay = typeof hide === 'number' && hide > 1 ? hide : 5000;
		setTimeout(() => hideLoading(), delay);
	}
}

/**
 * Nasconde la schermata di caricamento con un effetto fade-out e la rimuove dal DOM.
 */
export function hideLoading() {
	const loadingPage = document.querySelector('.page-loader');
	if (!loadingPage) return;

	fade(loadingPage, 250, 'out', () => loadingPage.remove());
}

/**
 * Imposta un focus trap nel menu (header) per mantenere il focus
 * all'interno quando la navigazione è attiva (body.nav-is-active).
 */
export function initMenuFocusTrap() {
	const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

	const targetItem = document.querySelector('header');
	if (!targetItem) return;

	const focusableContent = Array.from(targetItem.querySelectorAll(focusableElements));

	// Cache degli elementi visibili — aggiornata solo quando il menu si apre/chiude
	let visibleElements = [];

	const updateVisibleElements = () => {
		visibleElements = focusableContent.filter(el => el.offsetParent !== null);
	};

	// Ricalcola al termine della transizione CSS del menu
	targetItem.addEventListener('transitionend', updateVisibleElements);

	// Ricalcola anche subito quando nav-is-active viene aggiunto al body
	const bodyObserver = new MutationObserver(() => updateVisibleElements());
	bodyObserver.observe(document.body, { attributeFilter: ['class'], attributes: true });

	document.addEventListener('keydown', (e) => {
		if (!document.body.classList.contains('nav-is-active')) return;
		if (e.key !== 'Tab') return;

		const firstFocusableElement = visibleElements[0];
		const lastFocusableElement = visibleElements[visibleElements.length - 1];

		if (e.shiftKey) {
			// Shift + Tab: se si è sul primo elemento, sposta il focus sull'ultimo
			if (document.activeElement === firstFocusableElement) {
				lastFocusableElement.focus();
				e.preventDefault();
			}
		} else {
			// Tab: se si è sull'ultimo elemento, torna al primo
			if (document.activeElement === lastFocusableElement) {
				firstFocusableElement.focus();
				e.preventDefault();
			}
		}
	});
}

/**
 * Imposta il focus sul primo elemento focusabile all'interno del target fornito.
 * Esclude gli elementi con tabindex="-1" o data-focusable="-1".
 * @param {HTMLElement} target - Il contenitore in cui cercare il primo elemento focusabile.
 */
export function setFocusOnElement(target) {
	if (!target) return;

	const exclude = ':not([tabindex="-1"]):not([data-focusable="-1"])';
	const focusable = target.querySelectorAll(
		`input${exclude}, ` +
		`select${exclude}, ` +
		`textarea${exclude}, ` +
		`button${exclude}, ` +
		`[href]${exclude}, ` +
		`[tabindex]${exclude}`
	);

	const firstFocusable = focusable[0];
	if (firstFocusable) {
		firstFocusable.focus();
	}
}

/**
 * Aggiorna la barra della forza password in base al punteggio.
 * @param {number} score - Punteggio di forza della password (0–4).
 */
function updatePasswordStrengthBar(score) {
	const container = document.getElementById('password-strength-bar-container');
	const bar = document.getElementById('password-strength-bar');
	if (!container || !bar) return;

	const levels = [
		{ width: '0%', color: '#ccc' }, // 0 — nessuna
		{ width: '25%', color: '#dc2626' }, // 1 — molto debole (rosso)
		{ width: '50%', color: '#facc15' }, // 2 — debole (giallo)
		{ width: '75%', color: '#4ade80' }, // 3 — buona (verde chiaro)
		{ width: '100%', color: '#16a34a' }, // 4 — ottima (verde intenso)
	];

	const level = levels[score] ?? levels[0];

	container.classList.remove('hidden');
	container.setAttribute('aria-hidden', 'false');

	bar.style.width = level.width;
	bar.style.backgroundColor = level.color;
}

// Validators form // Valida e gestisce tutti i campi di una form
export function initFormValidation() {

	const forms = document.querySelectorAll('.needs-validation');
	if (forms.length === 0) return;

	/**
	 * Mostra o nasconde il feedback visivo di errore per un input.
	 * @param {HTMLElement} elm - L'elemento input da aggiornare.
	 * @param {boolean} valid - true per nascondere il feedback, false per mostrarlo.
	 */
	function showHideFeedback(elm, valid) {
		// — letture DOM —
		const wrap = elm.closest('.wrap-input');
		if (!wrap) return;
		const container = wrap.closest('.input-group') || wrap.parentElement;
		if (!container) return;
		const feedback = container.querySelector('.invalid-feedback');
		if (!feedback) return;
		const inputGroup = feedback.closest('.input-group');
		const inputGroupText = inputGroup ? inputGroup.querySelector('.input-group-text') : null;

		// — scritture DOM (tutte dopo le letture per evitare forced reflow) —
		if (!valid) {
			elm.classList.add('is-invalid');
			feedback.classList.add('is-invalid');
			inputGroupText?.classList.add('is-invalid');
		} else {
			elm.classList.remove('is-invalid');
			feedback.classList.remove('is-invalid');
			inputGroupText?.classList.remove('is-invalid');
		}
	}

	/**
	 * Verifica se una data è valida, passata e opzionalmente entro un limite di anni.
	 * @param {string} dateStr - Data in formato gg/mm/aaaa.
	 * @param {{ allowFuture?: boolean, maxPastYears?: number }} options
	 * @returns {boolean}
	 */
	function isValidPastDate(dateStr, { allowFuture = false, maxPastYears = null } = {}) {
		const parts = dateStr.split('/');
		if (parts.length !== 3) return false;

		const day = parseInt(parts[0], 10);
		const month = parseInt(parts[1], 10) - 1;
		const year = parseInt(parts[2], 10);

		const date = new Date(year, month, day);
		if (isNaN(date.getTime())) return false;

		if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) {
			return false;
		}

		const today = new Date();
		today.setHours(0, 0, 0, 0);

		const inputDate = new Date(date.getTime());
		inputDate.setHours(0, 0, 0, 0);

		if (!allowFuture && inputDate.getTime() > today.getTime()) return false;

		if (maxPastYears !== null) {
			const oldestAllowed = new Date(today.getFullYear() - maxPastYears, today.getMonth(), today.getDate());
			oldestAllowed.setHours(0, 0, 0, 0);
			if (inputDate.getTime() < oldestAllowed.getTime()) return false;
		}

		return true;
	}

	/**
	 * Applica messaggi di errore personalizzati per ciascun campo in base alla validità.
	 * @param {string} id - L'id del campo.
	 * @param {HTMLElement} invalidField - L'elemento input non valido.
	 */
	function setFeedback(id, invalidField) {

		// *** REGISTRAZIONE

		// 📅 Data di nascita
		if (id && id.endsWith('DataDiNascita')) {
			const errorSpan = document.getElementById('invalidDataDiNascita');
			if (!errorSpan) return;
			const value = invalidField.value;
			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = 'Digitare la data di nascita';
				invalidField.setCustomValidity('Digitare la data di nascita');
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Formato data non valido (es: 01/01/1980)';
				invalidField.setCustomValidity('Formato data non valido (es: 01/01/1980)');
			} else if (!isValidPastDate(value, { allowFuture: false, maxPastYears: 100 })) {
				errorSpan.textContent = 'Data non valida o non realistica';
				invalidField.setCustomValidity('Data non valida o non realistica');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}

		// ☎️ Telefono
		if (id && id.endsWith('Telefono')) {
			const errorSpan = document.getElementById('invalidTelefono');
			if (!errorSpan) return;
			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = 'Digitare il numero di telefono';
				invalidField.setCustomValidity('Digitare il numero di telefono');
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Inserire minimo 6 cifre';
				invalidField.setCustomValidity('Inserire minimo 6 cifre');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}

		// 👤 Codice fiscale
		if (id && id.endsWith('CodiceFiscale')) {
			const errorSpan = document.getElementById('invalidCodiceFiscale');
			if (!errorSpan) return;
			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = 'Digitare il codice fiscale';
				invalidField.setCustomValidity('Digitare il codice fiscale');
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Formato codice non valido';
				invalidField.setCustomValidity('Formato codice non valido');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}

		// 📧 Email
		if (id && id.endsWith('Email')) {
			const errorSpan = document.getElementById('invalidEmail');
			if (!errorSpan) return;
			const emailValue = invalidField.value;
			const confermaEmailInput = document.getElementById('Input_ConfermaEmail');

			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = `Digitare l'e-mail`;
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Formato e-mail non valido';
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}

			if (confermaEmailInput && confermaEmailInput.value !== '') {
				if (emailValue !== confermaEmailInput.value) {
					invalidField.setCustomValidity('Le e-mail non coincidono');
					errorSpan.textContent = 'Le e-mail non coincidono';
					errorSpan.style.display = 'block';
				} else {
					invalidField.setCustomValidity('');
					errorSpan.textContent = '';
					errorSpan.style.display = 'none';
				}
			}
		}

		// 📧 Conferma email
		if (id && id.endsWith('ConfermaEmail')) {
			const errorSpan = document.getElementById('invalidConfermaEmail');
			if (!errorSpan) return;
			const emailValue = document.getElementById('Input_Email').value;
			const confermaEmailValue = invalidField.value;

			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = `Digitare l'e-mail`;
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Formato e-mail non valido';
			} else if (emailValue !== confermaEmailValue) {
				errorSpan.textContent = 'Le e-mail non coincidono';
				invalidField.setCustomValidity('Le e-mail non coincidono');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}

		// 🔒 Password
		if (id && id.endsWith('Password')) {
			const errorSpan = document.getElementById('invalidPassword');
			if (!errorSpan) return;
			const passwordValue = invalidField.value;
			const confermaPasswordInput = document.getElementById('Input_ConfermaPassword');

			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = 'Digitare la password';
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Formato password errato';
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}

			if (confermaPasswordInput && confermaPasswordInput.value !== '') {
				if (passwordValue !== confermaPasswordInput.value) {
					invalidField.setCustomValidity('Le password non coincidono');
					errorSpan.textContent = 'Le password non coincidono';
					errorSpan.style.display = 'block';
				} else {
					invalidField.setCustomValidity('');
					errorSpan.textContent = '';
					errorSpan.style.display = 'none';
				}
			}

			// Verifica la forza della password (il campo deve avere la classe "strength")
			if (invalidField.classList.contains('strength')) {
				const result = zxcvbn(passwordValue);
				updatePasswordStrengthBar(result.score);
			}
		}

		// 🔒 Conferma password
		if (id && id.endsWith('ConfermaPassword')) {
			const errorSpan = document.getElementById('invalidConfermaPassword');
			if (!errorSpan) return;
			const passwordInput = document.getElementById('Input_Password');
			const passwordValue = passwordInput ? passwordInput.value : '';
			const confermaPasswordValue = invalidField.value;

			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = 'Digitare la conferma password';
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Formato password errato';
			} else if (!passwordInput.checkValidity()) {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			} else if (passwordValue !== confermaPasswordValue) {
				errorSpan.textContent = 'Le password non coincidono';
				invalidField.setCustomValidity('Le password non coincidono');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}

		// 🏢 Partita IVA
		if (id && id.endsWith('PartitaIva')) {
			const errorSpan = document.getElementById('invalidPartitaIva');
			if (!errorSpan) return;
			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = 'Digitare la partita Iva';
				invalidField.setCustomValidity('Digitare la partita Iva');
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Formato codice non valido';
				invalidField.setCustomValidity('Formato codice non valido');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}

		// 🔘 Checkbox privacy obbligatoria
		if (id && id.endsWith('Privacy1')) {
			const errorSpan = document.getElementById('InvalidPrivacy1');
			if (!errorSpan) return;
			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = 'Campo obbligatorio';
				invalidField.setCustomValidity('Campo obbligatorio');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}

		// 🔘 Radio privacy obbligatoria
		if (id && (id.endsWith('Privacy2_si') || id.endsWith('Privacy2_no'))) {
			const errorSpan = document.getElementById('invalidPrivacy2');
			if (!errorSpan) return;
			const radios = document.querySelectorAll('input[name="Input.Privacy2"]');
			const siSelected = Array.from(radios).some(r => r.value === 'si' && r.checked);
			if (!siSelected) {
				errorSpan.textContent = 'Campo obbligatorio';
				errorSpan.style.display = 'block';
				radios.forEach(r => r.setCustomValidity('Devi accettare la privacy'));
			} else {
				errorSpan.textContent = '';
				errorSpan.style.display = 'none';
				radios.forEach(r => r.setCustomValidity(''));
			}
		}

		// *** SCONTRINO / FATTURA

		// 📅 Data acquisto
		if (id && id.endsWith('DataAcquisto')) {
			const errorSpan = document.getElementById('invalidDataAcquisto');
			if (!errorSpan) return;
			const value = invalidField.value;
			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = 'Digitare la data di acquisto';
				invalidField.setCustomValidity('Digitare la data di acquisto');
			} else if (invalidField.validity.patternMismatch) {
				const todayStr = new Date().toLocaleDateString('it-IT');
				errorSpan.textContent = `Formato data non valido (es: ${todayStr})`;
				invalidField.setCustomValidity(`Formato data non valido (es: ${todayStr})`);
			} else if (!isValidPastDate(value, { allowFuture: false, maxPastYears: 1 })) {
				errorSpan.textContent = 'Data non valida o non realistica';
				invalidField.setCustomValidity('Data non valida o non realistica');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}

		// 🕒 Orario acquisto
		if (id && id.endsWith('OrarioAcquisto')) {
			const errorSpan = document.getElementById('invalidOrarioAcquisto');
			if (!errorSpan) return;
			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = `Digitare l'orario di acquisto`;
				invalidField.setCustomValidity(`Digitare l'orario di acquisto`);
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Formato orario non valido (es. 14:30)';
				invalidField.setCustomValidity('Formato orario non valido (es. 14:30)');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}

		// 🧾 Numero acquisto
		if (id && id.endsWith('NumeroAcquisto')) {
			const errorSpan = document.getElementById('invalidNumeroAcquisto');
			if (!errorSpan) return;
			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = 'Digitare il numero di acquisto';
				invalidField.setCustomValidity('Digitare il numero di acquisto');
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Formato numero non valido (es: 1234-5678)';
				invalidField.setCustomValidity('Formato numero non valido (es: 1234-5678)');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}

		// 💶 Importo acquisto
		if (id && id.endsWith('ImportoAcquisto')) {
			const errorSpan = document.getElementById('invalidImportoAcquisto');
			if (!errorSpan) return;
			if (invalidField.validity.valueMissing) {
				errorSpan.textContent = `Digitare l'importo di acquisto`;
				invalidField.setCustomValidity(`Digitare l'importo di acquisto`);
			} else if (invalidField.validity.patternMismatch) {
				errorSpan.textContent = 'Formato non valido (es: 10,99)';
				invalidField.setCustomValidity('Formato non valido (es: 10,99)');
			} else {
				errorSpan.textContent = '';
				invalidField.setCustomValidity('');
			}
		}
	}

	/**
	 * Aggiorna lo stato di validità visivo e ARIA per tutti i campi del form.
	 * @param {HTMLFormElement} form
	 * @returns {boolean} true se tutti i campi sono validi
	 */
	function handleValidation(form) {
		const fields = form.querySelectorAll('input:not([type="submit"]):not([type="reset"]), select, textarea');
		let isFormValid = true;

		fields.forEach((field) => {
			const isValid = field.validity.valid;

			if (isValid) {
				field.removeAttribute('aria-invalid');
				showHideFeedback(field, true);
			} else {
				isFormValid = false;
				field.setAttribute('aria-invalid', 'true');
				showHideFeedback(field, false);

				const id = field.getAttribute('id');
				if (id) {
					setFeedback(id, field);
				}
			}
		});

		return isFormValid;
	}

	// ✅ Aggiunge eventi di validazione in tempo reale agli input
	Array.from(forms).forEach(form => {
		const allInputs = form.querySelectorAll('input, select, textarea');

		allInputs.forEach((el) => {
			const eventType = (el.type === 'checkbox' || el.type === 'radio' || el.tagName === 'SELECT')
				? 'change'
				: 'input';

			el.addEventListener(eventType, function () {
				const id = el.getAttribute('id');

				// 🔠 Forza il codice fiscale in maiuscolo
				if (id === 'Input_CodiceFiscale') {
					this.value = this.value.toUpperCase();
				}

				setFeedback(id, el);

				if (el.checkValidity()) {
					el.removeAttribute('aria-invalid');
					if (form.classList.contains('was-validated')) {
						showHideFeedback(el, true);
					}
				} else {
					el.setAttribute('aria-invalid', 'true');
					if (form.classList.contains('was-validated')) {
						showHideFeedback(el, false);
					}
				}
			});
		});

		// ✅ Gestione del submit del form
		form.addEventListener('submit', (e) => {
			form.classList.add('was-validated');
			const isFormValid = handleValidation(form);
			if (!isFormValid) {
				e.preventDefault();
				e.stopPropagation();
				scrollToFirstErr();
			} else {
				showLoading();
			}
		});
	});

	/** ✅
	 * Correzione automatica ordine DOM per .form-floating
	 * Bootstrap richiede che la <label> sia dopo l'elemento input/select/textarea.
	 */
	document.querySelectorAll('.form-floating').forEach(container => {
		const label = container.querySelector('label');
		const input = container.querySelector('input, select, textarea');
		if (!label || !input) return;
		const labelIsBeforeInput = (input.compareDocumentPosition(label) & Node.DOCUMENT_POSITION_PRECEDING) !== 0;
		if (labelIsBeforeInput) {
			container.appendChild(label);
		}
	});

	/** ✅
	 * Sposta <label> all'esterno dei container .input-group privi di .form-floating.
	 */
	document.querySelectorAll('.input-group').forEach(group => {
		if (group.querySelector('.form-floating')) return;
		const label = group.querySelector('label');
		if (!label) return;
		group.parentNode.insertBefore(label, group);
	});
}

/**
 * Mostra o nasconde la password e aggiorna l'icona corrispondente.
 * Cerca tutti i bottoni con classe .btn-show-hide-pwd e ne gestisce il click.
 */
export function showHidePassword() {
	Array.from(document.querySelectorAll('.btn-show-hide-pwd')).forEach((element) => {
		element.addEventListener('click', (e) => {
			e.preventDefault();

			const rel = document.getElementById(element.dataset.rel);
			if (!rel) return;

			const eye = element.querySelector('.n');
			const eyeSlash = element.querySelector('.y');

			if (rel.type === 'password') {
				rel.type = 'text';
				eye.classList.add('d-none');
				eyeSlash.classList.remove('d-none');
			} else {
				rel.type = 'password';
				eye.classList.remove('d-none');
				eyeSlash.classList.add('d-none');
			}
		});
	});
}

/**
 * Chiude il menu di navigazione mobile e resetta lo stato ARIA dell'header.
 * Utilizzata da scrollToAnchor e scrollToFirstErr.
 * @param {HTMLElement} header - L'elemento header della pagina.
 */
function resetMenu(header) {
	if (!header) return;

	document.body.classList.remove('nav-is-active');
	header.querySelector('.hamburger')?.classList.remove('is-active');
	header.querySelector('.item-nav')?.classList.remove('is-active');

	header.querySelectorAll('[aria-expanded]').forEach((el) => {
		el.setAttribute('aria-expanded', 'false');
	});
}

/**
 * Esegue uno scroll animato verso un elemento identificato da un attributo data-anchor.
 * Unifica scrollToElm e scrollToHash — sostituisce entrambe le funzioni.
 * @param {string} anchor - Il valore dell'attributo data-anchor dell'elemento target.
 * @param {Event} [event] - Evento opzionale di cui prevenire il comportamento predefinito.
 */
export function scrollToAnchor(anchor, event) {
	if (event) {
		event.preventDefault();
	}

	let hh = 0;
	const header = document.querySelector('header');

	if (header) {
		// Sottrae l'altezza dell'header se fisso o sticky
		if (
			header.classList.contains('sticky-top') ||
			header.classList.contains('fixed') ||
			header.classList.contains('is-pinned')
		) {
			hh = header.offsetHeight;
		}

		resetMenu(header);
	}

	const elmAnchor = document.querySelector(`[data-anchor='${anchor}']`);
	if (!elmAnchor) {
		console.warn(`scrollToAnchor: elemento con data-anchor='${anchor}' non trovato`);
		return;
	}

	const offsetPosition = elmAnchor.getBoundingClientRect().top + window.scrollY - hh;
	window.scrollTo({
		top: offsetPosition,
		behavior: 'smooth'
	});
}

/**
 * Esegue uno scroll animato verso il primo campo non valido del form.
 */
export function scrollToFirstErr() {
	const SCROLL_OFFSET = 10; // Margine visivo sopra il campo in errore

	let hh = 0;
	const header = document.querySelector('header');
	if (header) {
		if (
			header.classList.contains('sticky-top') ||
			header.classList.contains('fixed') ||
			header.classList.contains('is-pinned')
		) {
			hh = header.offsetHeight;
		}
		resetMenu(header);
	}

	const firstInvalidElement = document.querySelector(
		'input[aria-invalid="true"], select[aria-invalid="true"], textarea[aria-invalid="true"]'
	);
	if (!firstInvalidElement) return;

	const offsetPosition = firstInvalidElement.getBoundingClientRect().top + window.scrollY - hh - SCROLL_OFFSET;
	window.scrollTo({
		top: offsetPosition,
		behavior: 'smooth'
	});
}

/**
 * Gestisce il comportamento se l'URL contiene un hash (es. #contatti):
 * esegue lo scroll verso l'elemento corrispondente e rimuove l'hash dall'URL.
 */
export function urlHasHash() {
	let urlHash = window.location.hash;
	if (!urlHash) return;

	// Rimuove il simbolo '#' iniziale per ottenere solo il nome dell'anchor
	urlHash = urlHash.replace(/^#/, '');

	const elmAnchor = document.querySelector(`[data-anchor='${urlHash}']`);
	if (elmAnchor) {
		scrollToAnchor(urlHash);
	}

	// Rimuove l'hash dall'URL mantenendo pathname e query string
	history.pushState('', document.title, window.location.pathname + window.location.search);
}

// Init AOS Animation // Funzione che inizializza AOS (Animate On Scroll) con configurazione personalizzata
export function initAOS() {
	AOS.init({
		// Impostazioni globali
		disable: false, // Disabilita AOS su specifici dispositivi o condizioni
		startEvent: 'DOMContentLoaded', // Evento che avvia l’inizializzazione
		initClassName: 'aos-init', // Classe aggiunta dopo l'inizializzazione
		animatedClassName: 'aos-animate', // Classe aggiunta quando l’elemento viene animato
		useClassNames: false, // Aggiunge data-aos come classe durante lo scroll se true
		disableMutationObserver: false, // Disabilita rilevamento automatico di mutazioni (avanzato)
		debounceDelay: 50, // Ritardo debounce durante il resize (in ms)
		throttleDelay: 99, // Ritardo throttle durante lo scroll (in ms)

		// Impostazioni specifiche per singolo elemento (sovrascrivibili via attributi data-aos)
		offset: 120, // Offset (in pixel) dal punto di trigger
		delay: 0, // Ritardo dell’animazione (0–3000 ms)
		duration: 1000, // Durata dell’animazione (0–3000 ms)
		easing: 'ease', // Tipo di easing predefinito
		once: false, // Se true, l’animazione avviene una sola volta
		mirror: false, // Se true, l’elemento si anima anche in uscita dallo schermo
		anchorPlacement: 'top-bottom', // Posizione dell’elemento rispetto alla finestra che innesca l’animazione
	});
}

// Memorizza l'elemento corrente con spinner attivo
export let activeSpinnerElement;

/**
 * Mostra uno spinner su un elemento interattivo e disabilita il body durante il caricamento.
 * @param {HTMLElement} elm - L'elemento su cui mostrare lo spinner.
 * @param {string} text - Testo di stato dello spinner (può contenere HTML).
 * @param {Event} [event] - Evento opzionale di cui prevenire il comportamento predefinito.
 */
export function showSpinner(elm, text, event) {
	if (event) {
		event.preventDefault();
	}

	activeSpinnerElement = elm;

	document.body.classList.add('pointer-event-none');

	elm.disabled = true;
	elm.setAttribute('aria-disabled', 'true');
	elm.classList.add('disabled');

	const spinner = elm.querySelector('.spinner-border');
	if (spinner) spinner.classList.remove('d-none');

	const spinnerStatus = elm.querySelector('.spinner-status');
	if (spinnerStatus) spinnerStatus.innerHTML = text;
}

/**
 * Nasconde lo spinner e riabilita il body e l'elemento precedentemente disabilitato.
 * Utilizza activeSpinnerElement impostato da showSpinner.
 * @param {string} text - Testo di stato da mostrare dopo il caricamento (può contenere HTML).
 */
export function hideSpinner(text) {
	document.body.classList.remove('pointer-event-none');

	if (!activeSpinnerElement) return;

	activeSpinnerElement.disabled = false;
	activeSpinnerElement.setAttribute('aria-disabled', 'false');
	activeSpinnerElement.classList.remove('disabled');

	const spinner = activeSpinnerElement.querySelector('.spinner-border');
	if (spinner) spinner.classList.add('d-none');

	const spinnerStatus = activeSpinnerElement.querySelector('.spinner-status');
	if (spinnerStatus) spinnerStatus.innerHTML = text;

	activeSpinnerElement = null;
}

/**
 * Mostra una finestra modale Bootstrap con titolo e messaggio dinamici.
 * @param {string} id - L'id dell'elemento modale nel DOM.
 * @param {string} title - Titolo della modale (può contenere HTML).
 * @param {string} message - Messaggio nel corpo della modale (può contenere HTML).
 * @param {Event} [event] - Evento opzionale di cui prevenire il comportamento predefinito.
 */
export function showCustomModal(id, title, message, event) {
	if (event) {
		event.preventDefault();
	}

	const modalEl = document.getElementById(id);
	if (!modalEl) return;

	const customModalTitle = document.querySelector('.modal-title');
	if (customModalTitle) customModalTitle.innerHTML = title;

	const customModalBody = document.querySelector('.modal-body');
	if (customModalBody) customModalBody.innerHTML = message;

	

	const customModal = new Modal(modalEl);
	customModal.show();
}

/**
 * Mostra una modale Bootstrap contenente un video YouTube in autoplay.
 * @param {string} id - L'ID del video YouTube da incorporare.
 * @param {string} title - Titolo della modale e dell'iframe (può contenere HTML).
 * @param {Event} [event] - Evento opzionale di cui prevenire il comportamento predefinito.
 */
export function showVideoModalYT(id, title, event) {
	if (event) {
		event.preventDefault();
	}

	const videoModal = document.getElementById('videoModal');
	const videoModalIframe = document.getElementById('videoModalIframe');
	const videoModalLabel = document.getElementById('videoModalLabel');
	if (!videoModal || !videoModalIframe || !videoModalLabel) return;

	const iframe = document.createElement('iframe');
	iframe.width = '560';
	iframe.height = '315';
	iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
	iframe.setAttribute('title', title);
	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
	iframe.setAttribute('allowfullscreen', '');

	videoModalIframe.innerHTML = '';
	videoModalIframe.appendChild(iframe);

	videoModalLabel.innerHTML = title;

	const modalVideo = new Modal(videoModal);
	modalVideo.show();

	// Rimuove l'iframe alla chiusura della modale per fermare il video
	// { once: true } evita l'accumulo di listener ad ogni apertura
	videoModal.addEventListener('hidden.bs.modal', () => {
		videoModalIframe.innerHTML = '';
	}, { once: true });
}